import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import ElementPlus, { ElNotification } from 'element-plus'
import Vue3Signature from 'vue3-signature'
import 'element-plus/dist/index.css'
import 'vue-scroll-picker/lib/style.css'

import App from './App.vue'
import router from './router'
import axios from 'axios'
import Worker from './worker?worker'

import * as Sentry from "@sentry/vue";
import Vue3Transitions from 'vue3-transitions'
import Camera from "simple-vue-camera";
import deviceApi from './deviceApi'
import VueJwtDecode from "vue-jwt-decode";
import { OpenAPI } from "@/client";
import { useSettingsStore } from './stores'
OpenAPI.BASE = import.meta.env.VITE_APP_API_URL.toString().replace("/api/", "");

const sentry_dsn = import.meta.env.VITE_SENTRY_DSN.toString();
const pinia = createPinia()
const app = createApp(App)

declare global {
    interface Window {
        clarity:any;
    }
}

Sentry.init({
  app,
  dsn: sentry_dsn,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  initialScope: (scope) => {
    if (localStorage.getItem('user') != null) {
      var user = JSON.parse(localStorage.getItem('user')!);
      scope.setTags({ user: user.id });
    } else {
      scope.setTags({ user: "unknown" });
    }
    return scope;
  },
  beforeBreadcrumb: (breadcrumb, hint) => {
    if (breadcrumb.category === 'xhr') breadcrumb.data = (hint?.xhr as XMLHttpRequest).response;
    return breadcrumb;
  },
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});


const worker = new Worker()
deviceApi.worker = worker;

app.use(Vue3Signature)
app.use(pinia)
app.use(router)
app.use(ElementPlus)
app.use(Vue3Transitions)
app.component("camera", Camera)


app.provide("worker", worker);
axios.defaults.baseURL = import.meta.env.VITE_APP_API_URL
axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response != undefined) {
      if (error.response.status === 401) {
        localStorage.clear()
        sessionStorage.clear()
        window.location.assign('/')
        Sentry.setUser(null);
      } else if (error.response.status === 403) {
        router.push('/')
      } else if (error.response.status === 400)  {
        if (error.response.data === 'SubscriptionInvalid') {
          ElNotification({
            title: 'Error',
            message: 'Subscription has ended, please contact your account owner.',
            type: 'error',
            duration: 0
            
          });
        } else if (!error.response.request.responseURL.includes('token')) {
          ElNotification({
            title: 'Error',
            message: error.response.data.message,
            type: 'error'
          });
        }
        return Promise.reject(error)
      } else {
        ElNotification({
          title: 'Error',
          message: error.response.data.message,
          type: 'error'
        });
        return Promise.reject(error)
      }
    } else {
      ElNotification({
        title: 'Error',
        message: error.message,
        type: 'error'
      });
    }
  }
)
axios.defaults.headers.common = { Authorization: `bearer ${localStorage.getItem('access_token')}` }

if (localStorage.getItem('user') != null) {
  let user = JSON.parse(localStorage.getItem('user')!);
  Sentry.setUser({ id: user.id, email: user.email });
  if (window.clarity) {
    const token = VueJwtDecode.decode(localStorage.getItem('access_token'))
    window.clarity('set', 'userId', user.id);
    window.clarity('set', 'userEmail', user.email);
    if (token) {
      window.clarity('set', 'lid', token.lid);
      window.clarity('set', 'tid', token.tid);
      window.clarity('set', 'ten', token.ten);

      var specificTenants = ["3d9bcde9-87f4-4e56-9888-aedce6bfca64", "b6dda16e-495a-4249-a93c-42edcd7eb79e"] 
      if (specificTenants.indexOf(token.tid)) {
        window.clarity("upgrade", "Looked for tenant")
      }
    }
  }

  const settingStore = useSettingsStore();
  settingStore.get();
}


app.mount('#app')
